import { SearchScenarioId } from 'owa-search-next-common';
import { action } from 'satcheljs';

const onRemoveGuidedFormulationPillInternal = action(
    'onRemoveGuidedFormulationPillInternal',
    (segmentKey: string, scenarioId: SearchScenarioId) => ({
        segmentKey,
        scenarioId,
    })
);

export default onRemoveGuidedFormulationPillInternal;
